import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '@tds/core-spinner';

const OrderButton = ({ button, isOrderValidating, actionChanged }) => {
  const { label, onClick, variant } = button;
  return (
    <Spinner label={label} size="small" spinning={isOrderValidating} inline>
      <button
        type="button"
        className={`frg-button color-${variant}`}
        disabled={!actionChanged}
        onClick={onClick}
      >
        {label}
      </button>
    </Spinner>
  );
};

OrderButton.propTypes = {
  button: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.string
  }).isRequired,
  isOrderValidating: PropTypes.bool.isRequired,
  isValidated: PropTypes.bool.isRequired
};

export default OrderButton;
